import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AuthGuard } from '@nx-ratenow/core/guards';
import { CoreI18nModule } from '@nx-ratenow/core/i18n';
import { UiCustomLayoutComponent } from '@nx-ratenow/core/layout/feature-custom-layout';
import { getUserLoggedResolver } from '@nx-ratenow/shared/resolvers';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('@nx-ratenow/core/feature-auth').then((m) => m.CoreFeatureAuthModule)
  },
  {
    path: 'errors',
    loadChildren: () => import('@nx-ratenow/core/errors/feature-error-pages').then((m) => m.CoreErrorsFeatureErrorPagesModule)
  },
  {
    path: '',
    component: UiCustomLayoutComponent,
    canActivate: [AuthGuard],
    resolve: { userLoggedInfo: getUserLoggedResolver },
    children: [
      {
        path: ':questionnaireId',
        loadChildren: () => import('@nx-ratenow/ctl/main').then((m) => m.CtlMainModule)
      },
      {
        path: 'documentation',
        loadChildren: () => import('@nx-ratenow/documentation/main').then((module) => module.DocumentationMainModule)
      },
      {
        path: 'case',
        loadChildren: () => import('@nx-ratenow/ctl/case-details/main').then((m) => m.CtlCaseDetailsMainCtlCaseDetailsModule)
      },
      {
        path: 'account-settings',
        loadChildren: () => import('@nx-ratenow/account-settings/main').then((module) => module.AccountSettingsMainModule)
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/errors/404'
  }
];

@NgModule({
  imports: [
    CoreI18nModule,
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      initialNavigation: 'enabledBlocking',
      paramsInheritanceStrategy: 'always',
      bindToComponentInputs: true
    })
  ],
  exports: [TranslateModule, RouterModule]
})
export class AppRoutingCTLModule {}
